// interceptors/requestInterceptor.ts
import { AxiosError } from 'axios';
import { skippableRequestInterceptor } from '../../config';
import { store } from '../../redux/store';
import { clearInvestmentData } from '../../redux/project/investmentSlice';
import { logout } from '../../redux/auth/authSlice';

// let store

// export const injectStore = _store => {
//   store = _store
// }

export const requestInterceptor = async (config: any) => {
  // get the path from the config
  const path = config.url;
  if (skippableRequestInterceptor.includes(path)) return config;

  const token = store.getState().auth.token;
  if (!token) {
    store.dispatch(clearInvestmentData());
    store.dispatch(logout());
    throw new Error('Not Authenticated');
  }
  if (config.headers) {
    config.headers['Authorization'] = token;
  }
  return config;
};

export const requestErrorInterceptor = async (error: AxiosError) => {
  return Promise.reject(error);
};
